import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actionCreators } from './store';
import abbr from '../../config/abbr';
import imgLogo from '../../assets/images/logo.png';
import imgMobileJt from '../../assets/images/mobile-jt.jpg';
import imgMobileEwm from '../../assets/images/ewm.png';
import imgMobileWebEwm from '../../assets/images/mob_url1.png';
import imgTeacherVideo from '../../assets/images/1568766708.png';
import './style.css';

class Header extends Component {
	
	constructor(){
		super()
		this.linkOut = this.linkOut.bind(this);
	}
	
	linkOut(url){
		const w = window.open('about:blank');
		w.location.href = url;
	}
	
	componentDidMount() {
		this.props.changeLoginState();
	}
	
	render() {
		const { stateIsLogin, loginOut } = this.props;
		return (
			<div className="lrheader">
				<div className="mx1200 mauto">
					<div className="top">
						<img src={imgLogo} alt="大立教育微视频" onClick={ev => this.linkOut(abbr.ipIndex)} className="cursp"/>
						<ul className="clear">
							<li className="downewm">手机下载
								<div className="mobile">
									<img src={imgMobileJt} className="jt" alt="建造师培训APP"/>
									<div className="mobile-top">
										<img src={imgMobileEwm} alt="建造师培训APP"/>
										<div className="mobile-top-text">
											<h3>网络课堂手机APP下载</h3>
											<p>直接扫描左侧二维码下载</p>
											<p>同时兼容安卓与苹果系统</p>
										</div>
									</div>
									<div className="mobile-bottom">
										<img src={imgMobileWebEwm} alt="大立教育手机端"/>
										<div className="mobile-bottom-text">
											<h3>大立教育手机Web端</h3>
											<p>1、直接输入 m.daliedu.cn</p>
											<p>2、扫描左侧二维码，登陆大立教育官网手机端</p>
										</div>
									</div>
								</div>
							</li>
							<li className="msykt">名师微课堂
								<div className="youketang">
									<img src={imgMobileJt} className="jt" alt="建造师培训APP"/>
									<img src={imgTeacherVideo} className="detailImg" alt="大立教育官方微博"/>
								</div>
							</li>
							{/* <li onClick={ev => this.linkOut('http://wx.dali24.com/')}>网络课堂</li> */}
							<li onClick={ev => this.linkOut('http://wx.daliedu.cn/')}>网络课堂</li>
							{/* <li onClick={ev => this.linkOut('http://www.dali24.com/job.html')}>招贤纳士</li> */}
							<li onClick={ev => this.linkOut('http://www.daliedu.cn/job.html')}>招贤纳士</li>
							{/* <li onClick={ev => this.linkOut('https://weibo.com/dalischool?sudaref=www.dali24.com&display=0&retcode=6102')}>微博</li> */}
							<li onClick={ev => this.linkOut('https://weibo.com/dalischool?sudaref=www.daliedu.cn&display=0&retcode=6102')}>微博</li>
							{/* <li onClick={ev => this.linkOut('http://www.dali24.com/topic/dali_wx/')}>微信</li> */}
							<li onClick={ev => this.linkOut('http://www.daliedu.cn/topic/dali_wx/')}>微信</li>
							{stateIsLogin ? (
								<li><span className="hp100 dislb" onClick={ev => this.linkOut('http://wx.daliedu.cn/uc/')}>个人中心</span>｜<span className="hp100 dislb" onClick={loginOut}>退出</span></li>
							) : (
								<li><span className="hp100 dislb" onClick={ev => this.linkOut(abbr.ipIndex+'login')}>登录</span>｜<span className="hp100 dislb" onClick={ev => this.linkOut(abbr.ipIndex+'register')}>注册</span></li>
							)}
							<li>400-6666-458</li>
						</ul>
					</div>
					<ul className="bottom clear">
						{/* <li onClick={ev => this.linkOut('http://www.dali24.com/')}>首页</li>
						<li className="cur" onClick={ev => this.linkOut(abbr.ipIndex)}>名师微课堂</li>
						<li onClick={ev => this.linkOut('http://wx.daliedu.cn/uc/courseselectonline')}>在线选课</li>
						<li onClick={ev => this.linkOut('http://www.dali24.com/news/zhibo/')}>直播课</li>
						<li onClick={ev => this.linkOut('http://www.dali24.com/news/jianzhang/')}>招生简章</li>
						<li onClick={ev => this.linkOut('http://wx.daliedu.cn/uc/chapterexercise')}>题库</li>
						<li onClick={ev => this.linkOut('http://www.dali24.com/news/')}>考试资讯</li>
						<li onClick={ev => this.linkOut('http://www.dalischool.com/book/booklist')}>辅导图书</li>
						<li onClick={ev => this.linkOut('http://wx.daliedu.cn/uc/learningquestions/hotquestions')}>有问必答</li>
						<li onClick={ev => this.linkOut('http://wx.daliedu.cn/uc/class')}>我的课程</li> */}

						<li onClick={ev => this.linkOut('http://www.daliedu.cn/')}>首页</li>
						<li className="cur" onClick={ev => this.linkOut(abbr.ipIndex)}>名师微课堂</li>
						<li onClick={ev => this.linkOut('http://wx.daliedu.cn/uc/courseselectonline')}>在线选课</li>
						<li onClick={ev => this.linkOut('http://www.daliedu.cn/news/zhibo/')}>直播课</li>
						<li onClick={ev => this.linkOut('http://www.daliedu.cn/news/jianzhang/')}>招生简章</li>
						<li onClick={ev => this.linkOut('http://wx.daliedu.cn/uc/chapterexercise')}>题库</li>
						<li onClick={ev => this.linkOut('http://www.daliedu.cn/news/')}>考试资讯</li>
						<li onClick={ev => this.linkOut('http://www.dalischool.com/book/booklist')}>辅导图书</li>
						<li onClick={ev => this.linkOut('http://wx.daliedu.cn/uc/learningquestions/hotquestions')}>有问必答</li>
						<li onClick={ev => this.linkOut('http://wx.daliedu.cn/uc/class')}>我的课程</li>
					</ul>
				</div>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		stateIsLogin: state.getIn(['header', 'stateIsLogin']),		
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		changeLoginState(){
			/*let userObj = localStorage.getItem('userObj');
			let lsisLogin='';
			if(userObj){
				lsisLogin = JSON.parse(userObj).accesstoken;
			}*/
			let lsisLogin = localStorage.getItem('lsisLogin');
			if(lsisLogin){
				dispatch(actionCreators.changeLoginState(true));
			}else{
				dispatch(actionCreators.changeLoginState(false));
			}
		},
		loginOut(){
			dispatch(actionCreators.loginOut());
		},
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);

